import React from "react";
import { Spinner } from "react-rainbow-components";
import "./Button.css";

const isDisabled = ({ disabled, isLoading, formik }) => {
  if (disabled) {
    return true;
  } else if (isLoading) {
    return true;
  } else if (formik) {
    if (formik.isValid && !formik.dirty) return true;
    else return false;
  } else return false;
};

export const TransparantIcon = ({
  onClick,
  disabled,
  isLoading,
  formik,
  className,
  children,
  animationIcon,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled({ disabled, isLoading, formik })}
      className={`transparant-icon-button ${className ? className : ""} ${
        animationIcon ? "loading-animation" : ""
      }`}
    >
      {isLoading ? (
        <div className="position-relative w-100 h-100">
          <Spinner
            className="transparant-button-spinner"
            size="x-small"
            type="arc"
            variant="brand"
          />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export const NextButton = ({
  onClick,
  disabled,
  isLoading,
  formik,
  className,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled({ disabled, isLoading, formik })}
      className={`next-button ${className ? className : ""}`}
    >
      {isLoading ? (
        <div className="position-relative w-100 h-100">
          <Spinner
            className="next-button-spinner"
            size="x-small"
            type="arc"
            variant="brand"
          />
        </div>
      ) : (
        <img src="/icons/next-brown-arrow.svg" alt="next"></img>
      )}
    </button>
  );
};

export const OrangeSquareButton = ({
  onClick,
  disabled,
  className,
  children,
  isLoading,
  formik,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled({ disabled, isLoading, formik })}
      className={`orange-square-button ${className ? className : ""}`}
    >
      {isLoading ? (
        <div className="position-relative w-100 h-100">
          <Spinner
            className="orange-square-spinner"
            size="x-small"
            type="arc"
            variant="brand"
          />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export const IconTextButton = ({
  onClick,
  disabled,
  children,
  icon,
  btnOrder,
  className,
}) => {
  const getClassName = () => {
    let newClassName = "";

    if (btnOrder === "first") newClassName = "rounded-top";
    else newClassName = "rounded-bottom second-dropdown-btn";

    if (className) newClassName = `${newClassName} ${className}`;

    return newClassName + " " + "icon-text-button";
  };

  return (
    <button onClick={onClick} disabled={disabled} className={getClassName()}>
      <div className="d-flex">
        <span style={{ margin: "0px 8px 0px 2px" }}>
          <img src={icon} alt="icon"></img>
        </span>
        <span style={{ color: "#572148", marginTop: "3px" }}>{children}</span>
      </div>
    </button>
  );
};
